// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WZBxg","colBig":"styles_colBig__Ev0wl","colSmall":"styles_colSmall__E9_aX"};